<template>
  <div class="aoform__step" :class="{'aoform__step_hidden': hideCondition}">
    <h2 class="aoform__title aoform__title_lesspace">Спасибо! <br>Образец договора готов.</h2>
    <CheckData />
    <Filler />
    <p class="aoform__text">Нажимая на кнопку «Подтвердить», я подтверждаю ознакомление с&nbsp;условиями и правилами страхования и Ключевым информационным документом</p>
    <BtnContainer>
      <FormBtn @click.native="confirm">Подтвердить</FormBtn>
      <FormBtn :nodecor="true" @click.native="$store.commit('prevStep')">Редактировать данные</FormBtn>
    </BtnContainer>
  </div>
</template>

<script>
import FormTitles from '@/mixins/FormTitles.vue'
import FormBtn from '@/components/FormBtn.vue'
import BtnContainer from '@/components/BtnContainer.vue'
import CheckData from '@/components/CheckData.vue'
import Filler from '@/components/Filler.vue'

export default {
  components: { FormBtn, BtnContainer, CheckData, Filler},
  mixins: [FormTitles],
  props:{
    hideCondition: {type: Boolean, required: true}
  },
  methods: {
    confirm(){
      this.$store.commit('nextStep')
      document.dispatchEvent(new Event('ym-sms'))
    }
  },
}
</script>

<style>

</style>